import { TreeNode } from 'primeng/api';
import { FilterTypes } from '../../../models/filterEnums.model';
import { FilterCriteria } from '../shared/filter-criteria.model';

export class ShareholderCharacteristicsCriteria extends FilterCriteria {
  public override title = 'Characteristics of a Shareholder';
  public override type: FilterTypes = FilterTypes.ShareholderCharacteristics;
  shareholderCharacteristics: TreeNode[] = null;
  percentageOfOwnership: string = null;
  minimumPercent: number = null;
  maximumPercent: number = null;

  public override validate(): boolean {
    return this.shareholderCharacteristics && this.shareholderCharacteristics.length > 0;
  }

  public override toString(): string {
    const s: string[] = [];

    if (this.percentageOfOwnership) {
      s.push(
        `Ownership: ${this.percentageOfOwnership} Min %: ${this.minimumPercent ? this.minimumPercent : 'N/A'}, Max %: ${
          this.maximumPercent ? this.maximumPercent : 'N/A'
        }`
      );
    }
    if (this.shareholderCharacteristics) {
      s.push(`Types: ${this.shareholderCharacteristics.map((a) => a.label).join(', ')}`);
    }
    return s.join(' | ');
  }
}
